import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import StockOrientationSelect from '../../../common/StockOrientationSelect';

const ImageElementStockImagesOrientationSelect = (props) => {
    const {
        onOrientationChange,
        imageElementStockImagesOrientation,
        setImageElementStockImagesOrientation,
    } = props;

    return (
        <StockOrientationSelect
            onOrientationChange={onOrientationChange}
            mediaOrientation={imageElementStockImagesOrientation}
            setStockMediaOrientation={setImageElementStockImagesOrientation}
        />
    );
};

const mapStateToProps = (state) => {
    const {
        imageElementStockImagesOrientation,
        imageStockImagesOrientation
    } = state.mediaPicker;

    return {
        imageElementStockImagesOrientation: imageElementStockImagesOrientation ?? imageStockImagesOrientation
    };
};

const mapDispatchToProps = (dispatch) => {
    const setImageElementStockImagesOrientation = (orientation) => dispatch(mediaPickerActions.setImageElementStockImagesOrientation(orientation));

    return {
        setImageElementStockImagesOrientation
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageElementStockImagesOrientationSelect);
